ApplicationSerializer = require './application'

App.StaticPageSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    parent: 
      serialize: 'id'
      deserialize: 'record'

